const HOST_URL = process.env.REACT_APP_HOST_IMAGE;
export const API_URL = process.env.REACT_APP_CMS_API;
export const TINY_MCE_KEY = process.env.REACT_APP_TINY_MCE_KEY;
export default HOST_URL;
